import React from "react";
import {AppState} from "../../../../app/types";

export const BotsBroadcastTab = (p: {appState: AppState}) => {
    return <div>BROADCASTS HERE</div>;
};
